<script setup>
import { useQuasar } from 'quasar';
import { computed } from 'vue';

const $q = useQuasar();

const color = computed(() => {
    return $q.dark.isActive
        ? 'grey-9'
        : 'brown-1';
});

const textColor = computed(() => {
    return $q.dark.isActive
        ? 'white'
        : 'brown-9';
});
</script>

<template>
    <q-chip :color :textColor square class="generic-chip rounded-borders">
        <slot></slot>
    </q-chip>
</template>

<style lang="scss">
.q-chip.generic-chip i {
    margin-left: auto;
    margin-right: auto;
}
</style>
